"use strict";

/* ================================
   Wishlist Page Script (Fixed)
================================ */

const wishlistDiv = document.querySelector(".wishlist-page-main");

var WishlistPageShopify = (function () {
  return {
    initWishlistItems: function () {
      if (window.location.search.indexOf("page=") === -1) {
        this.init();
      }
    },

    init: function () {
      const _this = this;

      if (!wishlistDiv) return;

      const wishlist_items =
        JSON.parse(localStorage.getItem("glozin__wishlist-items")) || [];

      const div_no_product = wishlistDiv.querySelector(
        ".wishlist-no-product-js"
      );

      if (!wishlist_items.length) {
        _this.skeletonFunction(0);
        div_no_product && div_no_product.classList.remove("hidden");
        return;
      }

      let query = "";
      wishlist_items.forEach((id, index) => {
        query += index !== wishlist_items.length - 1 ? `${id}%20OR%20id:` : id;
      });

      const section_id = document.querySelector(".wishlist-page-section")
        ?.dataset.sectionId;

      if (!section_id) return;

      const productAjaxURL =
        "?section_id=" +
        section_id +
        "&type=product&options[unavailable_products]=last&q=id:" +
        query;

      fetch(`${window.routes.search_url}${productAjaxURL}`)
        .then((res) => res.text())
        .then((htmlText) => {
          const parser = new DOMParser();
          const html = parser.parseFromString(htmlText, "text/html");

          const wishlistHTML = html.querySelector(".wishlist-page-main");

          if (wishlistHTML) {
            wishlistDiv.innerHTML = wishlistHTML.innerHTML;
            _this.skeletonFunction(700);
            _this.mergeItems();
            _this.removeWishlistItem(); // 🔥 FIX
          } else {
            _this.skeletonFunction(0);
            div_no_product && div_no_product.classList.remove("hidden");
          }
        })
        .catch(console.error)
        .finally(() => {
          typeof initLazyloadItem === "function" && initLazyloadItem();
        });
    },

    /* ================================
       REMOVE ITEM FROM WISHLIST
    ================================ */
    removeWishlistItem: function () {
      wishlistDiv.addEventListener("click", function (e) {
        const btn = e.target.closest("button-wishlist");
        if (!btn) return;

        const productId = btn.dataset.productId;
        if (!productId) return;

        let items =
          JSON.parse(localStorage.getItem("glozin__wishlist-items")) || [];

        items = items.filter((id) => id !== productId);

        localStorage.setItem("glozin__wishlist-items", JSON.stringify(items));

        const productItem = btn.closest(".product-item");
        if (productItem) {
          productItem.style.transition = "opacity 0.3s ease";
          productItem.style.opacity = "0";
          setTimeout(() => productItem.remove(), 300);
        }

        if (!items.length) {
          const emptyDiv = wishlistDiv.querySelector(
            ".wishlist-no-product-js"
          );
          emptyDiv && emptyDiv.classList.remove("hidden");
        }
      });
    },

    /* ================================
       SYNC LOCAL STORAGE
    ================================ */
    mergeItems: function () {
      const arr = [];
      wishlistDiv
        .querySelectorAll("button-wishlist[data-product-id]")
        .forEach((btn) => arr.push(btn.dataset.productId));

      localStorage.setItem("glozin__wishlist-items", JSON.stringify(arr));
    },

    /* ================================
       SKELETON HANDLER
    ================================ */
    skeletonFunction: function (timer) {
      setTimeout(() => {
        document.querySelector("skeleton-page")?.remove();
        document
          .querySelector(".wishlist-page-section-inner")
          ?.classList.remove("hidden");
      }, timer);
    },
  };
})();

WishlistPageShopify.initWishlistItems();